import { FeatureFlagIf } from './directives/featureFlagIf.directive';
import { FeatureFlagElse } from './directives/featureFlagElse.directive';
import { FeatureFlagWrapper } from './directives/feature_flag_wrapper.component';
import { FeatureFlagService } from './services/featureFlag.service';


export const FeatureFlagModule = angular
    .module('oo.featureFlag', [])
    .factory('featureFlagService', FeatureFlagService)
    .directive('featureFlagIf', FeatureFlagIf)
    .directive('featureFlagElse', FeatureFlagElse)
    .component('featureFlagWrapper', FeatureFlagWrapper)
    .name;
